module.exports = __webpack_public_path__ + "img/28-R7S.abb4103.png";